import React , {useState} from "react";
import edit_icon from "../assets/Images/edit.png";
import delete_icon from "../assets/Images/delete.png";
import close_icon from "../assets/Images/close_small_portfolio.svg";
import more_vert from "../assets/Images/more_vert_portfolio.svg";
import pwa_image from "../assets/Images/pwa_image.png";
import visa from "../assets/Images/visa.png";
import amex from "../assets/Images/amex.png";
import cc_generic from "../assets/Images/cc_generic.png";
import city_double_cash from "../assets/Images/city_double_cash.png";
import check_everyday from "../assets/Images/check_everyday.png";
import { PaymentMethod} from "../types/types";
import { useNavigate } from "react-router-dom";
import {usePaymentMethodsDeleteMutation} from '../services/AsaApiServices'
import ConfirmDialog from "../components/ConfirmDialog ";
import showSubscriptionToast from "../screens/SubscriptionManagement/SubscriptionToast";
import { useTranslation } from "react-i18next";
interface PaymentMethodCardProps {
  method: PaymentMethod;
  isSelected: boolean;
  isSelectable: boolean;
  currentCVV: string;
  onSelect: (method: PaymentMethod) => void | undefined;
  onCVVChange: (e: React.ChangeEvent<HTMLInputElement>, paymentMethodId: number) => void;
  buttonColor:string|undefined
}
const vertPoints=(isDarkMode:boolean)=>{
  var fillColor=isDarkMode?"#FFFFFF":"#4E4E4E"
  return(
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  
  <circle cx="12" cy="5" r="2" fill={fillColor}/>
  <circle cx="12" cy="12" r="2" fill={fillColor}/>
  <circle cx="12" cy="19" r="2" fill={fillColor}/>
</svg>

)}
const closePoints=(isDarkMode:boolean)=>{
  var strokeColor=isDarkMode?"#FFFFFF":"#4E4E4E"
  return(
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="18.364" y1="5.63604" x2="5.63604" y2="18.364" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<line x1="18.364" y1="18.364" x2="5.63604" y2="5.63604" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}
export const getImageSource = (type: string |null,cardNumber:string|null) => {
    switch (type) {
      case "ACH":
        return check_everyday;
      case "Bank":
        return check_everyday; // Assuming Bank uses the same image as check_everyday
      case "Visa":
        return visa;
      case "CC":
        
        if(cardNumber?.startsWith("4")){
          return visa
        }else if(cardNumber?.startsWith("3")){
          return amex
        }else if(cardNumber?.startsWith("5")){
          return city_double_cash 
        }     
          return cc_generic;
      default:
        return pwa_image;
    }
  };

const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({
  method,
  isSelected,
  isSelectable,
  currentCVV,
  onSelect,
  onCVVChange,
  buttonColor

}) => {
    const [moreOpen, setMoreOpen] = useState(false);
    const navigate = useNavigate();
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const paymentDeleteMutation=usePaymentMethodsDeleteMutation()
    const { t } = useTranslation();
    const isDarkMode=document.body.classList.contains('dark');
    const handleConfirmedDelete = async () => {
        try {
            setShowConfirmDialog(false)
            const requestData={
            asaPaymentMethodCode: method?.asaPaymentMethodCode,
            } 
            var response=await paymentDeleteMutation.mutateAsync(requestData)
            //setShowConfirmDialogPayment(false);
        } catch (error) {
            showSubscriptionToast(error?.message, true);
            console.error("Error deleting billing address:", error);
        }
    }
    const handleCVVBlur = () => {

    };
  
    const handleCVVClick = (e: React.MouseEvent) => {
      e.stopPropagation();
    };
  return (
    <>
    {showConfirmDialog && 
        <ConfirmDialog
        title={t("deletePaymMethodConfirmTitle")}
        message={t("deletePaymMethodConfirmMessage")}
        onCancel={() => setShowConfirmDialog(false)}
        onConfirm={handleConfirmedDelete} // Ensure this function is called on confirmation
        isOpen={showConfirmDialog}
        />
    }
    <div
      className={`flex items-center justify-between p-2 rounded-lg cursor-pointer mb-3`}
      style={{
        backgroundColor: isSelected && isSelectable? (!isDarkMode? "#D9D9D9": "#2c2c2c" ): "transparent",
        boxShadow: isSelected && isSelectable? "0px 4px 4px rgba(0, 0, 0, 0.25)" : "none",
      }}
    >
       <div className="flex items-center space-x-2 flex-grow">     
        {isSelectable &&
            
            <div
                className="form-radio-outer circle-icon-pportfolio"
                onClick={() => onSelect(method)}
                >
                <div
                    className={`circle-pport ${
                    isSelected ? "circle-pport-large" : "circle-pport-small"
                    }`}
                    style={{background:`${buttonColor}`}}
                  
                />
            </div>
        }
        <div className="bg-white rounded p-1">
          <img
            src={getImageSource(method?.paymentType,method?.cardNumber)}
            alt={method.paymentType}
            className="w-8 h-5 rounded"
            style={{ objectFit: "contain" }}
          />
        </div>
        <span className= "font-poppins-600 truncate-portfolio ">
          {method?.paymentMethodName}
        </span>

        {(method.paymentType === "CC" && isSelected) ? (
          <div className="flex flex-grow items-end justify-end mr-10">
            <input
              type="password"
              placeholder="CVV"
              value={currentCVV || ""}
              maxLength={4}
              onChange={(e) => onCVVChange(e, method?.paymentMethodId)}
              onBlur={handleCVVBlur}
              onClick={handleCVVClick}
              inputMode="numeric"

              className="border-none dark:border-solid bg-[#FFFFFF] dark:bg-[#616161] rounded-[10px]  w-20 h-8 rounded font-poppins-600-16 dark:text-white text-[#4E4E4E] text-base outline-none text-center box-border "
            />
          </div>
        ) : (
          <div className="flex flex-grow items-end justify-end">
            <div className="font-poppins-600  font-semibold text-base leading-24">
              ••••{" "}
              {method.paymentType === "CC"
                ? method?.last4DigitsOfCardNumber
                : method?.last4DigitsOfAccountNumber}
            </div>
          </div>
        )}
      </div>
      {!isSelected &&
        <div className="w-6 h-6  ml-2">

        </div>
      }
      {isSelected && (
        <>
          {moreOpen ? (
            <div className="flex items-center space-x-2 ml-auto">
              <button
                className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
                onClick={(e) => {
                    e.stopPropagation(); 
                    navigate("/addcreditcard", { replace:true, state: { payment: method,returnurl:"/subscriptionpayment" }});
                }}
              >
                <img
                  className="w-6 h-6 cursor-pointer"
                  src={edit_icon}
                  alt="Edit"
                />
              </button>
              <button
                className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
                onClick={(e)=>{
                  e.stopPropagation(); 
                  setShowConfirmDialog(true)}
                }
              >
                <img
                  className="w-6 h-6 cursor-pointer"
                  src={delete_icon}
                  alt="Delete"
                />
              </button>
              <button
                className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the click event from bubbling up to the parent element
                  setMoreOpen(false)
                }}
              >
                {closePoints(isDarkMode)}
              </button>
            </div>
          ) : (
            <div className="flex items-center">
              <button
                className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents the click event from bubbling up to the parent element
                  setMoreOpen(true)
                }}
              >
                {vertPoints(isDarkMode)}

              </button>
            </div>
          )}
        </>
      )}
    </div>
    </>
  );
};

export default PaymentMethodCard ;
